import React, { useState } from 'react'
import { Drawer, Upload } from 'antd'
import { useSnackbar } from 'notistack'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { AiOutlineInbox } from 'react-icons/ai'

import { usePet, useToggle, notifOps } from '../../modules'

import Datepicker from '../reusable/datePicker'
import Confirm from '../reusable/confirm'

const { Dragger } = Upload

const UploadReferral = ({ reload = () => null, onPerform = () => null }) => {
    const [referredFrom, setReferredFrom] = useState('')
    const [date, setDate] = useState()
    const [file, setFile] = useState([])

    const [visible, toggleVisible] = useToggle(true)

    const { enqueueSnackbar } = useSnackbar()
    const { params } = useSelector((state) => state.application)

    const history = useHistory()
    const { id } = useParams()

    const props = {
        name: 'referral',
        fileList: file,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange: (info) => {
            let { fileList } = info
            fileList = fileList.slice(-1)
            let temp = fileList[0]

            const isOK = temp?.type === 'image/jpeg' || temp?.type === 'image/png' || temp?.type === 'application/pdf'
            if (!isOK) {
                enqueueSnackbar('Please upload either an image or pdf', notifOps('warning'))
                return false
            }

            const isLarge = (temp?.size / 1024 / 1024) > params?.maxFileUploadSize
            if (isLarge)
                enqueueSnackbar(`Please upload a file smaller than ${params?.maxFileUploadSize} MB`, notifOps('warning'))

            if (isOK && !isLarge) setFile(fileList)
        },
        beforeUpload: () => false,
        onDrop: (e) => {
            console.log('Dropped files', e.dataTransfer.files)
        },
    }

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 100)
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        reload()
        notif('Referral has been uploaded', ops('success'))
        setTimeout(close, 300)
    }

    const [{ loading }, uploadReferral] = usePet(
        'uploadReferral',
        {
            patient: id,
            referredFrom,
            date,
            referral: file[0]?.originFileObj,
        },
        { hasFile: true, notify: true, callback: onComplete, manual: true, load: { msg: 'Uploading referral...' } },
    )

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button
                        onClick={() =>
                            Confirm({
                                title: 'Upload Referral?',
                                message: 'Please confirm before uploading this referral document',
                                onOk: uploadReferral,
                                okText: 'Upload Referral',
                            })}
                        className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                        Upload Referral
                    </button>
                </div>
            }
            width={500}>
            <p className="font-extrabold text-3xl mb-0">Upload Referral</p>
            <div className="divide-y divide-light-gray-400">
                <div className="w-full mt-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Referred From
                    </label>
                    <input
                        onChange={(e) => setReferredFrom(e.target.value)}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-name"
                        type="text"
                        value={referredFrom}
                        name="name"
                        placeholder="Facility Name"
                    />
                </div>
                <div className="w-full pt-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Referral Date
                    </label>
                    <Datepicker value={date} onChange={setDate} />
                </div>
                <div className="w-full pt-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Upload File
                    </label>
                    <Dragger {...props}>
                        <p className="ant-upload-drag-icon flex justify-center">
                            <AiOutlineInbox size={40} />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">Please select a pdf or image file (pdf/jpg/jpeg/png)</p>
                    </Dragger>
                </div>
            </div>
        </Drawer>
    )
}

export default UploadReferral
